import type {FC, PropsWithChildren} from 'react';

import {cn} from '@/utils/tailwind';

interface Props extends PropsWithChildren {
	classNameOverride?: {
		figure?: string;
		figcaption?: string;
		credit?: string;
		caption?: string;
	};
	credit?: string;
	caption?: string;
}

export const Figure: FC<Props> = ({
	children,
	classNameOverride,
	credit,
	caption,
}) => {
	if (!credit && !caption) {
		return children;
	}

	return (
		<figure
			className={cn(['relative', 'h-full', classNameOverride?.figure])}
		>
			{children}
			<figcaption
				className={cn([
					'flex',
					'flex-wrap',
					'justify-between',
					'gap-x-4',
					'gap-y-1',
					'mt-3',
					'text-body-short-xs',
					classNameOverride?.figcaption,
				])}
			>
				{caption && (
					<span
						className={cn([
							'text-neutral-text-subtle',
							classNameOverride?.caption,
						])}
					>
						{caption}
					</span>
				)}
				{credit && (
					<span
						className={cn([
							'text-primary-text-subtle',
							classNameOverride?.credit,
						])}
					>
						{credit}
					</span>
				)}
			</figcaption>
		</figure>
	);
};
